import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Nothing but net",
    description: "A file uploader where every upload is a shot through a basketball hoop. Drag a file, flick it, and watch it drop through the net.",
    url: getOrigin()
}
